// A claim nobody has handled yet is RECEIVED, which reviewers read as pending
export const claimDisplayStatus = (status) => (!status || status === "RECEIVED" ? "PENDING" : status);

export const CLAIM_TYPE_LABELS = {
  BURSARY: "Bursary",
  LOCAL_LOAN: "Local Loan",
  ABROAD_SCHOLARSHIP: "Abroad Scholarship",
};

export const claimTypeLabel = (type) => CLAIM_TYPE_LABELS[type] || type || "—";

export const claimAcademicYear = (claim) => claim.academicYear?.name || "—";
